"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Jul 09 2018
 */

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject"); // tslint:disable:max-classes-per-file

/**
 * <p>Maps external id of {@link Product product} and {@link ProductSensitivity sensitivity group}.</p>
 *
 * @author Jme
 */


var ProductSensitivityTuple =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSensitivityTuple, _DomainObject_1$Domai);

  /**
   * Ctor.
   * @param pExtId {@link Product.externalId}
   * @param groupExtId {@link ProductSensitivity.externalId}
   */
  function ProductSensitivityTuple(pExtId, groupExtId) {
    var _this;

    _classCallCheck(this, ProductSensitivityTuple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityTuple).call(this));
    _this.pExtId = pExtId;
    _this.groupExtId = groupExtId;
    return _this;
  }

  return ProductSensitivityTuple;
}(DomainObject_1.DomainObject);

exports.ProductSensitivityTuple = ProductSensitivityTuple;
/**
 * ProductSensitivity represents product's price sensitivity segmentation group,
 * such as KVI (key value items), Daily Essentials or Rest of assortment (Others).
 * Every product sensitivity group can be set with different strategy and constraints
 * for price calculation purpose according to the company goals. Assignment of product
 * sensitivity segment to products is through data upload. New internal products, without
 * reference product (predecessor), have assigned default product sensitivity group.
 *
 *
 * @author JMe
 */

var ProductSensitivity =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(ProductSensitivity, _DomainObject_1$Domai2);

  /**
   * Constructs product sensitivity group.
   *
   * @param id the internal id of product sensitivity
   * @param externalId the external id, used for pairing during data upload of product sensitivity
   * @param title
   * @param isDefault the flag that determines
   */
  function ProductSensitivity(id, externalId, title, isDefault) {
    var _this2;

    _classCallCheck(this, ProductSensitivity);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivity).call(this));
    _this2.id = id;
    _this2.externalId = externalId;
    _this2.title = title;
    _this2.isDefault = isDefault;
    return _this2;
  }

  return ProductSensitivity;
}(DomainObject_1.DomainObject);

exports.ProductSensitivity = ProductSensitivity;
ProductSensitivity.PRODUCT_SENSITIVITY_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.ProductSensitivity; // tslint:disable-next-line:member-ordering

ProductSensitivity.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductSensitivity.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    title: builder.str('title'),
    isDefault: builder.bool('isDefault')
  };
}();